import { useState } from 'react';
import { DragState } from '../types';

export const useCropState = () => {
  // Crop mode state
  const [cropMode, setCropMode] = useState(false);
  
  // Simple crop drawing state
  const [isDrawingCrop, setIsDrawingCrop] = useState(false);
  const [currentCropDraw, setCurrentCropDraw] = useState<{x: number, y: number, width: number, height: number} | null>(null);
  
  // Simple crop manipulation state
  const [isDraggingCrop, setIsDraggingCrop] = useState(false);
  const [cropDragStart, setCropDragStart] = useState<DragState>({x: 0, y: 0});
  const [isResizingCrop, setIsResizingCrop] = useState<string | null>(null);
  const [tempCropManipulation, setTempCropManipulation] = useState<{x: number, y: number, width: number, height: number} | null>(null);

  const clearCropState = () => {
    setCropMode(false);
    setIsDrawingCrop(false);
    setCurrentCropDraw(null);
    setIsDraggingCrop(false);
    setIsResizingCrop(null);
    setTempCropManipulation(null);
  };

  return {
    cropMode,
    setCropMode,
    isDrawingCrop,
    setIsDrawingCrop,
    currentCropDraw,
    setCurrentCropDraw,
    isDraggingCrop,
    setIsDraggingCrop,
    cropDragStart,
    setCropDragStart,
    isResizingCrop,
    setIsResizingCrop,
    tempCropManipulation,
    setTempCropManipulation,

    // Utility functions
    clearCropState
  };
};